/* eslint-disable @typescript-eslint/no-unused-vars */
import { Col, DatePicker, Form, FormInstance, Row, Typography } from "antd";
import CompanyCard from "containers/Admin/CreateOrEditEvent/Cards/CompanyCard";
import moment, { Moment } from "moment";
import { EditEventFormType } from "../CreateOrEditEvent";

const { Text } = Typography;

interface Props {
  form: FormInstance<EditEventFormType>;
}

const CompanyCardTime: React.FC<Props> = ({ form }) => {
  const adjustMomentWithoutSeconds = (value: Moment | null) => (value ? moment(value).set({ second: 0 }) : null);

  const formatString = "YYYY-MM-DDTHH:mm:ssZ";

  const onChangeStartTime = (value: Moment | null) => {
    const adjustedValue = adjustMomentWithoutSeconds(value);
    if (adjustedValue) {
      form.setFieldsValue({ start: adjustedValue.format(formatString) });
      form.setFieldsValue({ close: moment(adjustedValue).add(-1, "days").format(formatString) });
      form.setFieldsValue({ open: moment(adjustedValue).set({ h: 12, m: 0 }).add(-5, "days").format(formatString) });
    }
  };

  const onChangeOpenTime = (value: Moment | null) => {
    form.setFieldsValue({ open: adjustMomentWithoutSeconds(value)?.format(formatString) });
  };

  const onChangeCloseTime = (value: Moment | null) => {
    form.setFieldsValue({ close: adjustMomentWithoutSeconds(value)?.format(formatString) });
  };

  const getValueProps = (value: string | undefined) => ({
    value: value ? moment(value).set({ second: 0 }) : null,
  });

  return (
    <>
      <CompanyCard title="Tider">
        <Row gutter={[10, 5]}>
          <Col>
            <Form.Item<EditEventFormType>
              name="start"
              label="Arrangementstidspunkt"
              getValueProps={getValueProps}
              rules={[{ required: true, message: "Velg tidspunkt for arrangementet" }]}
            >
              <DatePicker
                size="large"
                showTime
                allowClear={false}
                onChange={onChangeStartTime}
                format="DD.MM.YYYY HH:mm"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Text italic style={{ marginBottom: "20px" }}>
            Under velges tidspunkt for når arrangementet automatisk åpner for påmelding, og når avmelding stenges. Dette
            settes automatisk ut ifra arrangementstidspunkt, og er som regel ikke nødvendig å endre.
          </Text>
          <Col md={12} sm={24} xs={24} style={{ marginBottom: "10px" }}>
            <Form.Item<EditEventFormType>
              name="open"
              label="Åpning"
              getValueProps={getValueProps}
              rules={[{ required: true, message: "Velg tidspunkt for åpning av påmelding" }]}
            >
              <DatePicker
                size="large"
                showTime
                allowClear={false}
                onChange={onChangeOpenTime}
                format="DD.MM.YYYY HH:mm"
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={24} xs={24}>
            <Form.Item<EditEventFormType>
              name="close"
              label="Stengning"
              getValueProps={getValueProps}
              rules={[{ required: true, message: "Velg tidspunkt for stengning av avemlding" }]}
            >
              <DatePicker
                size="large"
                showTime
                allowClear={false}
                onChange={onChangeCloseTime}
                format="DD.MM.YYYY HH:mm"
              />
            </Form.Item>
          </Col>
        </Row>
      </CompanyCard>
    </>
  );
};

export default CompanyCardTime;
